<div *ngIf="visible" class="seasonal-overlay" (click)="close()">
  <div class="seasonal-modal" (click)="$event.stopPropagation()">

    <!-- Close button -->
    <button class="close-btn" (click)="close()" title="Close">
      <i class="fas fa-times"></i>
    </button>

    <!-- Carousel -->
    <div class="carousel-wrap">

      <!-- Prev arrow -->
      <button
        *ngIf="images.length > 1"
        class="arrow arrow-left"
        (click)="prev()"
        title="Previous">
        <i class="fas fa-chevron-left"></i>
      </button>

      <!-- Image -->
      <div class="img-container">
       
        <img
          [src]="images[currentIndex].filename"
          alt="Seasonal Notice {{ currentIndex + 1 }}"
          class="ad-image"
          draggable="false"
        />
      </div>

      <!-- Next arrow -->
      <button
        *ngIf="images.length > 1"
        class="arrow arrow-right"
        (click)="next()"
        title="Next">
        <i class="fas fa-chevron-right"></i>
      </button>

    </div>

    <!-- Footer: dots + counter + skip -->
    <div class="popup-footer">

      <div class="dots" *ngIf="images.length > 1">
        <span
          *ngFor="let img of images; let i = index"
          class="dot"
          [class.active]="i === currentIndex"
          (click)="goTo(i)">
        </span>
      </div>

      <div class="footer-actions">
        <span class="img-counter" *ngIf="images.length > 1">
          {{ currentIndex + 1 }} / {{ images.length }}
        </span>
        <button class="skip-btn" (click)="skipForToday()">
          Don't show today
        </button>
      </div>

    </div>

  </div>
</div>
